import React, { useState } from "react";
import { useEffect } from "react";
import { useParams, useLocation } from "react-router-dom";
import { getRecommends, getSingleCombination } from "../../Helpers/lib";
import { useMediaHook } from "../useMediaHook";
import ModalDynamic from "./ModalDynamic";

const getProductIdFromPath = () =>
  window.location.pathname.split("/").filter(Boolean).pop();

const ModelDynamicRecommend = () => {
  let id = useParams();
  const query = useLocation();

  const [recommends, setRecommends] = useState([]);
  const productId = getProductIdFromPath();
  const [isLoading, setIsLoading] = useState(true);

  const [combination, setCombination] = useState({});
  useEffect(() => {
    let rpId = query.search.split("?").pop();
    rpId = !rpId?.startsWith("rpId") ? "" : rpId.split("=").pop();
    console.clear();

    if (rpId) {
      getSingleCombination(rpId)
        .then((data) => {
          setCombination(data.combination);
        })
        .catch((errr) => {})
        .finally(() => {
          setIsLoading(false);
        });
    } else {
      getRecommends(productId)
        .then((data) => {
          setRecommends(data.recommendProducts);
        })
        .catch((err) => {})
        .finally(() => {
          setIsLoading(false);
        });
    }
  }, []);
  useEffect(() => {
    console.log("combination ", combination);
  }, [combination]);
  const isMdOrDown = useMediaHook();
  if (isLoading) return null;
  return (
    <ModalDynamic
      matchparams={id}
      isMdOrDown={isMdOrDown}
      recommends={recommends}
      combination={combination}
    />
  );
};

export default ModelDynamicRecommend;
